import Component from 'flarum/common/Component';
import SpeciesReferenceBox from './SpeciesReferenceBox';
/**
 * "Taxons enfants" box on the species page - every direct child of this
 * species (GBIF's own or ChecklistBank's, depending on the actor's own
 * preference - see SpeciesChildrenResource), e.g. the subspecies/varieties
 * under a species, or the species under a genus. Lives in the sidebar right
 * after SpeciesSynonymsBox (see SpeciesPage.js) - same look-and-feel as
 * that box (a .ChampisSpeciesSearch-label header, a bordered card, rows
 * built from .SpeciesPage-referenceLink) and the same "Charger davantage"
 * pagination-of-an-already-fetched-list pattern, for a genus/family page
 * with a long children list - see SpeciesReferenceBox for the shared
 * implementation.
 */
export default class SpeciesChildrenBox extends Component {
  view(vnode) {
    return m(SpeciesReferenceBox, {
      gbifId: vnode.attrs.gbifId,
      endpoint: "species-children",
      sectionClass: "SpeciesPage-children",
      loadMoreClass: "SpeciesPage-childrenLoadMore",
      headerKey: "champis-species.forum.species_page.children_header"
    });
  }
}
flarum.reg.add('champis-species', 'forum/components/SpeciesChildrenBox', SpeciesChildrenBox);